module.exports = __webpack_public_path__ + "static/media/force_india.8b43ad45.jpg";